'use strict';
const angular = require('angular');

/*@ngInject*/
export function ViolationCodesService($resource) {
  return $resource('/api/violation-codes/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.ViolationCodesService', [])
  .factory('ViolationCodesService', ViolationCodesService)
  .name;



// WEBPACK FOOTER //
// ./client/components/violation-codes/violation-codes.service.js